import mutations from './mutations';

const state = {
  asOfDate: null,
  factSetAsOfDate: null,
  marketCapLarge: 0,
  marketCapMedium: 0,
  marketCapSmall: 0,
  weightedAvg: 0
};

export default {
  state,
  mutations
};
